import { useTrainerWorkHistory } from "api/hooks";
import { PaziaLoader } from "components/atoms";
import { formatDate } from "utils";
import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { TrainerWorkHistoryEventApi } from "api";
import { routes } from "consts";
interface TrainerWorkHistoryProps {
  trainerId: number;
}

export const TrainerWorkHistory = ({ trainerId }: TrainerWorkHistoryProps) => {
  const { loading, data } = useTrainerWorkHistory(trainerId);

  if (loading || !data) return <PaziaLoader />;

  const eventsGroupedByCourseAndSortedByDate = data.events.reduce(
    (acc, event) => {
      const courseId = event.course.courseId.toString();
      if (!acc[courseId]) {
        acc[courseId] = [];
      }
      acc[courseId].push(event);
      return acc;
    },
    {} as Record<string, TrainerWorkHistoryEventApi[]>,
  );
  return (
    <div>
      <h2 className="mb-2 font-semibold text-slate-800 dark:text-slate-100">Historia pracy</h2>
      <div className="rounded-sm border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <ul className="space-y-3">
          {data.events.length < 1 ? (
            <div className="text-sm">Trener nie prowadził jeszce szkolenia zarejestrowanego w systemie.</div>
          ) : (
            Object.entries(eventsGroupedByCourseAndSortedByDate).map(([courseId, courseEvents]) => (
              <HistoryEventRow
                key={courseId}
                courseName={courseEvents[0].course.courseName}
                courseId={Number(courseId)}
                events={courseEvents}
              />
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

interface HistoryEventRowProps {
  courseName: string;
  courseId: number;
  events: TrainerWorkHistoryEventApi[];
}
const HistoryEventRow = ({ courseName, events, courseId }: HistoryEventRowProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <li>
      <div
        className="cursor-pointer sm:flex sm:items-center sm:justify-between"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center text-sm sm:grow">
          <div className="my-2 mr-3 h-8 w-8 shrink-0 rounded-full bg-slate-600">
            <svg className="h-8 w-8 fill-current text-indigo-50" viewBox="0 0 32 32">
              <path d="M8.994 20.006a1 1 0 0 1-.707-1.707l4.5-4.5a1 1 0 0 1 1.414 0l3.293 3.293 4.793-4.793a1 1 0 1 1 1.414 1.414l-5.5 5.5a1 1 0 0 1-1.414 0l-3.293-3.293L9.7 19.713a1 1 0 0 1-.707.293Z" />
            </svg>
          </div>
          <div>
            <div className="font-medium text-slate-800 dark:text-slate-100">{courseName}</div>
            <div className="flex flex-nowrap items-center space-x-2 whitespace-nowrap">
              <div>{events.length} zdarzeń</div>
              <div className="text-slate-400 dark:text-slate-600">|</div>
              <a
                target="_blank"
                href={routes.COURSES_EDIT_NESTED.SCHEDULE(courseId)}
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-2.5 py-0.5 text-xs font-medium leading-5 text-slate-500 shadow-sm duration-150 ease-in-out hover:border-slate-300 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400 dark:hover:border-slate-600"
              >
                Zobacz kurs
              </a>
            </div>
          </div>
        </div>
        <div className="mt-2 sm:ml-2 sm:mt-0">
          <ul className="-m-1 flex flex-wrap sm:justify-end">
            <li className="m-1">
              <button className="text-slate-500 hover:text-slate-700">
                {isExpanded ? <MdKeyboardArrowUp size={18} /> : <MdKeyboardArrowDown size={18} />}
              </button>
            </li>
          </ul>
        </div>
      </div>
      {isExpanded && (
        <div className="mt-2 flex flex-col gap-x-2 gap-y-1">
          {events.map(({ event }) => (
            <div key={event.courseScheduleId} className="flex items-center gap-2">
              <div className="flex gap-1 text-sm text-slate-500">
                <div className="text-slate-400 dark:text-slate-600">·</div>
                <div className="w-24">
                  {event.timeFrom} - {event.timeTo}
                </div>
                <div className="w-24">{formatDate(event.eventDate, false, false)}</div>
              </div>
              <div className="pl-2 text-sm text-slate-500">{event.name}</div>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};
